(function () {
  'use strict'
  if (window.Shopify && window.Shopify.designMode) return
  if (window.__CHICCHOK_GMC_EVIDENCE_V1__) return
  window.__CHICCHOK_GMC_EVIDENCE_V1__ = true

  var storageKey = 'chicchok_gmc_evidence_v1'
  var cleanupKey = 'chicchok_gmc_clear_pending_v1'
  var lifetime = 30 * 24 * 60 * 60 * 1000
  var ownedKeys = ['evidence_version', 'evidence_type', 'click_sha256', 'campaign', 'landing_path', 'variant_id', 'first_touch_at', 'last_touch_at', 'expires_at', 'cart_binding', 'paid_conflict']
  var enabled = false
  var epoch = 0
  var memory = null
  var memoryOnly = false
  var queue = Promise.resolve()
  var timer = null
  var refreshTimer = null
  var expiryTimer = null
  var failures = 0
  var checks = 0
  var lastCheck = 0
  var captureStarted = false
  var cleanupPending = false
  var permissionReady = false
  var featureRequested = false

  function stored() {
    if (memoryOnly) return memory
    try { return JSON.parse(window.localStorage.getItem(storageKey) || 'null') }
    catch (error) { return memory }
  }

  function save(value) {
    memory = value
    try {
      if (value) window.localStorage.setItem(storageKey, JSON.stringify(value))
      else window.localStorage.removeItem(storageKey)
      memoryOnly = false
    } catch (error) { memoryOnly = true }
  }

  function pendingCleanup(value) {
    cleanupPending = value
    try {
      if (value) window.localStorage.setItem(cleanupKey, '1')
      else window.localStorage.removeItem(cleanupKey)
    } catch (error) {}
  }

  function valid(value) {
    if (!value || value.version !== '1') return null
    var now = Date.now()
    var first = Date.parse(value.first)
    var last = Date.parse(value.last)
    var expires = Date.parse(value.expires)
    if (!Number.isFinite(first) || !Number.isFinite(last) || !Number.isFinite(expires)) return null
    if (first > now + 60000 || last < first || last > now + 60000 || expires <= now || expires - first !== lifetime || last >= expires) return null
    if (value.type !== 'native_srsltid' && value.type !== 'manual_feed_utm') return null
    if (value.type === 'native_srsltid' && !/^[a-f0-9]{64}$/.test(value.click || '')) return null
    if (value.click && !/^[a-f0-9]{64}$/.test(value.click)) return null
    if (!/^[a-f0-9]{64}$/.test(value.signature || '')) return null
    if (typeof value.path !== 'string' || value.path.length > 200 || (value.path && (!value.path.startsWith('/') || /[?#\\\s<>@]/.test(value.path)))) return null
    if (value.variant && !/^\d{1,24}$/.test(value.variant)) return null
    if (value.campaign && !/^(sag_organic|merchant_free_listings|gmc_free_listings|shopping free listings)$/.test(value.campaign)) return null
    if (value.paid !== '0' && value.paid !== '1') return null
    return value
  }

  function digest(value) {
    if (!window.crypto || !window.crypto.subtle || typeof TextEncoder !== 'function') return Promise.resolve('')
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buffer) {
      return Array.from(new Uint8Array(buffer)).map(function (byte) { return byte.toString(16).padStart(2, '0') }).join('')
    })
  }

  function consent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy
      if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.analyticsProcessingAllowed !== 'function') return null
      return privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true
    } catch (error) { return null }
  }

  function route(file) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'
    var url = new URL(root + file, window.location.origin)
    if (url.origin !== window.location.origin || !/\/cart\/(?:update\.js)$|\/cart\.js$/.test(url.pathname)) throw new Error('cart_route')
    return url.href
  }

  function request(file, attributes) {
    var controller = new AbortController()
    var deadline = window.setTimeout(function () { controller.abort() }, 1800)
    var options = { method: attributes ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal, keepalive: Boolean(attributes) }
    if (attributes) {
      options.headers = { 'Content-Type': 'application/json' }
      options.body = JSON.stringify({ attributes: attributes })
    }
    return window.fetch(route(file), options).then(function (response) {
      if (!response.ok) throw new Error('cart_request')
      return response.json()
    }).finally(function () { window.clearTimeout(deadline) })
  }

  function attributes(value, binding) {
    var values = {
      __gmc_evidence_version: '1', __gmc_evidence_type: value.type,
      __gmc_click_sha256: value.click, __gmc_campaign: value.campaign,
      __gmc_landing_path: value.path, __gmc_variant_id: value.variant,
      __gmc_first_touch_at: value.first, __gmc_last_touch_at: value.last,
      __gmc_expires_at: value.expires, __gmc_cart_binding: binding,
      __gmc_paid_conflict: value.paid
    }
    var result = {}
    Object.keys(values).forEach(function (key) { result[key + '__'] = values[key] })
    return result
  }

  function enqueue(work) {
    queue = queue.then(work, work).catch(function () {
      failures += 1
      if (failures <= 2) schedule(1200 * failures)
    })
  }

  function clearCart() {
    var empty = {}
    ownedKeys.forEach(function (key) { empty['__gmc_' + key + '__'] = '' })
    return request('cart/update.js', empty).then(function () {
      pendingCleanup(false)
      failures = 0
    })
  }

  function removeEvidence() {
    var hadEvidence = Boolean(memory || stored() || cleanupPending)
    save(null)
    window.clearTimeout(expiryTimer)
    if (hadEvidence) pendingCleanup(true)
    if (cleanupPending) schedule(0)
  }

  function expiry(value) {
    window.clearTimeout(expiryTimer)
    expiryTimer = window.setTimeout(function () {
      var current = valid(stored())
      if (current && enabled && consent() === true) expiry(current)
      else removeEvidence()
    }, Math.min(Math.max(Date.parse(value.expires) - Date.now(), 1), 2147483647))
  }

  function sync() {
    if (cleanupPending) {
      return clearCart().then(function () {
        if (enabled && consent() === true && valid(stored())) schedule(0)
      })
    }
    if (!enabled || consent() !== true || checks >= 40 || failures > 2) return Promise.resolve()
    if (Date.now() - lastCheck < 300) { schedule(310 - (Date.now() - lastCheck)); return Promise.resolve() }
    var value = valid(stored())
    if (!value) {
      if (memory || stored()) removeEvidence()
      return Promise.resolve()
    }
    var startedEpoch = epoch
    lastCheck = Date.now()
    checks += 1
    return request('cart.js').then(function (cart) {
      if (!enabled || consent() !== true || startedEpoch !== epoch) return
      var token = typeof cart.token === 'string' ? cart.token : ''
      if (!token || token.length > 2048) return
      return digest(token).then(function (binding) {
        if (!binding || !enabled || consent() !== true || startedEpoch !== epoch) return
        value = valid(stored())
        if (!value) return removeEvidence()
        var payload = attributes(value, binding)
        var signature = JSON.stringify(payload)
        if (value.synced === signature) return
        if (!enabled || consent() !== true || startedEpoch !== epoch) return
        return request('cart/update.js', payload).then(function () {
          if (!enabled || consent() !== true || startedEpoch !== epoch) return
          var current = valid(stored())
          if (current && current.signature === value.signature && current.paid === value.paid) {
            current.synced = signature
            save(current)
          }
          failures = 0
        })
      })
    })
  }

  function schedule(delay) {
    window.clearTimeout(timer)
    timer = window.setTimeout(function () { enqueue(sync) }, typeof delay === 'number' ? delay : 350)
  }

  function paidEntry(params) {
    return ['gclid', 'gbraid', 'wbraid'].some(function (key) { return Boolean(params.get(key)) }) || /^(cpc|ppc|cpm|paid|paidsearch|paid_search|paid-social|paid_social|display)$/.test((params.get('utm_medium') || '').toLowerCase())
  }

  function capture() {
    if (!enabled || consent() !== true) return Promise.resolve()
    var currentEpoch = epoch
    var params = new URLSearchParams(window.location.search)
    var current = valid(stored())
    if (!current && (memory || stored())) removeEvidence()
    var campaign = (params.get('utm_campaign') || '').toLowerCase()
    var knownCampaign = /^(sag_organic|merchant_free_listings|gmc_free_listings|shopping free listings)$/.test(campaign)
    var manual = (params.get('utm_source') || '').toLowerCase() === 'google' && knownCampaign
    var rawClick = params.get('srsltid') || ''
    var native = /^[A-Za-z0-9_-]{8,512}$/.test(rawClick)
    var isPaid = paidEntry(params)
    if (!native && !manual) {
      if (current && isPaid && current.paid !== '1') {
        current.paid = '1'
        current.synced = ''
        save(current)
      }
      if (current) { expiry(current); schedule(0) }
      return Promise.resolve()
    }
    var path = window.location.pathname
    if (path.length > 200 || /[?#\\\s<>@]/.test(path) || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages)\/[A-Za-z0-9_\/-]+\/?)?$/i.test(path)) path = ''
    var variant = params.get('variant') || ''
    if (!/^\d{1,24}$/.test(variant)) variant = ''
    return Promise.all([native ? digest(rawClick) : Promise.resolve(''), digest(JSON.stringify(native ? ['native_srsltid', rawClick] : ['manual_feed_utm', campaign, path, variant]))]).then(function (hashes) {
      if (!enabled || consent() !== true || currentEpoch !== epoch || !hashes[1] || (native && !hashes[0])) return
      current = valid(stored())
      var nowMs = Date.now()
      var now = new Date(nowMs).toISOString()
      var same = current && current.signature === hashes[1]
      if (same) {
        if (isPaid) { current.paid = '1'; current.synced = '' }
      } else {
        current = {
          version: '1', type: native ? 'native_srsltid' : 'manual_feed_utm', click: hashes[0],
          campaign: knownCampaign ? campaign : '', path: path, variant: variant,
          first: current ? current.first : now, last: now,
          expires: current ? current.expires : new Date(nowMs + lifetime).toISOString(),
          paid: isPaid || (current && current.paid === '1') ? '1' : '0', signature: hashes[1], synced: ''
        }
      }
      if (!valid(current)) return
      save(current)
      expiry(current)
      schedule(0)
    }).catch(function () {})
  }

  function refresh() {
    var allowed = consent()
    if (allowed === null) {
      if (!featureRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        featureRequested = true
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { refresh() }) } catch (error) {}
      }
      return
    }
    permissionReady = true
    if (allowed !== enabled) { enabled = allowed; epoch += 1; captureStarted = false; failures = 0 }
    if (!enabled) { removeEvidence(); return }
    if (!captureStarted) {
      captureStarted = true
      enqueue(capture)
    } else schedule()
  }

  function wake() {
    refresh()
  }

  try { cleanupPending = window.localStorage.getItem(cleanupKey) === '1' } catch (error) {}
  document.addEventListener('visitorConsentCollected', refresh)
  window.addEventListener('pageshow', wake)
  window.addEventListener('focus', wake)
  window.addEventListener('online', function () {
    failures = 0
    refresh()
    if (cleanupPending) schedule(0)
  })
  window.addEventListener('storage', function (event) {
    if (event.key === storageKey || event.key === cleanupKey) {
      try { cleanupPending = window.localStorage.getItem(cleanupKey) === '1' } catch (error) {}
      if (cleanupPending || (enabled && consent() === true)) schedule()
    }
  })
  ;['cart:updated', 'cart:change', 'cart:refresh', 'product:added', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, function () { if (enabled) schedule() })
  })
  document.addEventListener('pointerdown', function (event) {
    if (enabled && event.target && event.target.closest && event.target.closest('a[href*="/checkout"], [name="checkout"], .shopify-payment-button, shopify-accelerated-checkout')) schedule(0)
  }, { capture: true, passive: true })
  document.addEventListener('submit', function (event) {
    if (!enabled || !event.target || !event.target.action) return
    try {
      var destination = new URL(event.target.action, window.location.href)
      if (destination.origin === window.location.origin && /\/cart(?:\/add)?\/?$|\/checkout(?:\/|$)/.test(destination.pathname)) schedule(0)
    } catch (error) {}
  }, { capture: true, passive: true })
  if (typeof PerformanceObserver === 'function') {
    try {
      var observer = new PerformanceObserver(function (entries) {
        if (!enabled) return
        if (entries.getEntries().some(function (entry) {
          try {
            var url = new URL(entry.name)
            return url.origin === window.location.origin && /\/cart\/(?:add|change|clear)(?:\.js)?\/?$/.test(url.pathname)
          } catch (error) { return false }
        })) schedule()
      })
      observer.observe({ type: 'resource', buffered: false })
    } catch (error) {}
  }
  if (cleanupPending) schedule(0)
  refresh()
  var attempts = 0
  function waitForPrivacy() {
    attempts += 1
    refresh()
    if (!permissionReady && attempts < 10) refreshTimer = window.setTimeout(waitForPrivacy, 500)
  }
  if (!permissionReady) refreshTimer = window.setTimeout(waitForPrivacy, 500)
})()
